<button
  class="profile-card focusable-element"
  [tabindex]="index"
  [ngClass]="{ selected: selected }"
  (click)="onProfileClick()"
>
  <div class="profile-icon-container">
    <app-icon
      class="profile-icon"
      [icon]="'my-aha-profile-icon-' + (isLast ? 'kids' : index)"
    ></app-icon>
    <ng-container *ngIf="selected">
      <app-icon
        [icon]="'my-aha-selected-profile'"
        class="tick-indicator"
        alt="selected"
      ></app-icon>
    </ng-container>
  </div>
  <div class="profile-label" [style]="'fontSize.20' | translate">
    {{ label }}
  </div>
</button>
